import {MasterOfActsAPI} from "../../api/api";

const SUCCESS_LOAD_PROJECTS = 'projectReducer/SUCCESS_LOAD_PROJECTS'
const ERROR_LOAD_PROJECTS = 'projectReducer/ERROR_LOAD_PROJECTS'
const SET_SELECTED_PROJECT = 'projectReducer/SET_SELECTED_PROJECT'


const initialState = {
    projects: [],
    selectedProject: null,
    loading: true,
    error: null
}

export const projectReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUCCESS_LOAD_PROJECTS:
            return {
                ...state,
                projects: action.projects,
                loading: false
            }
        case ERROR_LOAD_PROJECTS:
            return {...state, loading: false, error: 'Что-то пошло не так... Попробуйте перезагрузить страницу'}
        case SET_SELECTED_PROJECT:
            return {...state, selectedProject: action.selectedProject}
        default:
            return state
    }
}


export const getProjects = (state) => state.projectReducer
export const getProjectsId = (state) => state.projectReducer.selectedProject

export const successLoadProjects = (projects) => ({type: SUCCESS_LOAD_PROJECTS, projects})
export const errorLoadProjects = () => ({type: ERROR_LOAD_PROJECTS})
export const setSelectedProject = (selectedProject) => ({type: SET_SELECTED_PROJECT, selectedProject})


export const loadingProjects = contract => async dispatch => {
    const response = await MasterOfActsAPI.getProjects(contract)
    if (response.status === 200 && response.data.length !== 0) {
        dispatch(successLoadProjects(response.data))
    } else {
        dispatch(errorLoadProjects())
    }
}
